"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useResizedObserver = require("./useResizedObserver");
Object.keys(_useResizedObserver).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useResizedObserver[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useResizedObserver[key];
    }
  });
});